import { render, staticRenderFns } from "./RwsTripDetail.vue?vue&type=template&id=00704f38&scoped=true&"
import script from "./RwsTripDetail.vue?vue&type=script&lang=js&"
export * from "./RwsTripDetail.vue?vue&type=script&lang=js&"
import style0 from "./RwsTripDetail.vue?vue&type=style&index=0&id=00704f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00704f38",
  null
  
)

export default component.exports